import { Toaster } from "sonner";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Manifesto from "@/components/site/Manifesto";
import Features from "@/components/site/Features";
import DayNarrative from "@/components/site/DayNarrative";
import MarqueeStrip from "@/components/site/MarqueeStrip";
import Waitlist from "@/components/site/Waitlist";
import Footer from "@/components/site/Footer";

export default function Landing() {
  return (
    <div className="bg-[#F8F7F1] text-[#2B2B26] min-h-screen">
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#2B2B26",
            color: "#F8F7F1",
            border: "none",
            borderRadius: "999px",
            fontFamily: "Figtree, sans-serif",
          },
        }}
      />
      <Nav />
      <main>
        <Hero />
        <Manifesto />
        <Features />
        <DayNarrative />
        <MarqueeStrip />
        <Waitlist />
      </main>
      <Footer />
    </div>
  );
}
